import { Directive, ElementRef, Input, OnInit } from '@angular/core';
import { ElementControlService } from '../../core/services';
import { isNullOrEmpty } from '../../core/utils';

/**
 * 畫面元素控制設定 Directive
 *
 * @export
 * @class ElementControlDirective
 * @implements {OnInit}
 */
@Directive({
  selector: '[sigvElementControl]',
})
export class ElementControlDirective implements OnInit {
  /**
   * 分類
   */
  @Input() controlCategory: any;

  /**
   * 元素 ID
   */
  @Input('sigvElementControl') elementId: any;

  constructor(
    private el: ElementRef,
    private elementControlServcice: ElementControlService
  ) {}

  ngOnInit(): void {
    let display = false;
    const test = this.elementControlServcice.checkIsUnderControl(
      this.controlCategory,
      this.elementId
    );
    const config = this.elementControlServcice.getControlItem(
      this.controlCategory,
      this.elementId
    );
    if (isNullOrEmpty(config) === false) {
      if (config.display === true) {
        display = true;
      }
    }

    const targetEle = this.el.nativeElement as HTMLElement;
    if (display === false) {
      targetEle.remove();
    }
  }
}
